<template>
  <div>
    <sign-up :project-id="projectId" :class-id="classId" :project-name="projectName" v-bind:is-sign-up.sync="isSignUp" />
    <sign-up-zz :project-id="projectId" :class-id="classId" v-bind:is-sign-up-zz.sync="isSignUpZz" />
    <Top />
    <div class="maindiv pindex-wrap bg-f6">
      <Banner />
      <div class="sys htmldiv tright twhite ofhidden">
        <!-- <a href="/sims/web" class="zbtn zbtn-gblue2 fr">
        <div class="fs24 mb5">管理端入口</div>
        <div class="fmt tupper">Management side</div>
      </a> -->
        <a href="/lms/web" class="zbtn zbtn-gblue2 fr" target="_blank">
          <div class="fs24 mb5">学习端入口</div>
          <div class="fmt tupper">Learning Entrance</div>
        </a>
      </div>

      <div class="htmldiv mt25">
        <!--项目-->
        <div class="ptlist dflex mb25">
          <div class="types dflex-column justify-content-between tcenter">
            <div @click="trainType = 1" :class="{active: trainType == 1}"
              class="fs24 dflex justify-content-center align-items-center mb25 cpointer prelative">
              社会培训
              <span class="pabsolute line"></span>
            </div>
            <div @click="trainType = 5" :class="{active: trainType == 5}"
              class="fs24 dflex justify-content-center align-items-center mb25 cpointer prelative">
              特种作业操作工<br />培训与考证
              <span class="pabsolute line"></span>
            </div>
            <div @click="trainType = 4" :class="{active: trainType == 4}"
              class="fs24 dflex justify-content-center align-items-center mb25 cpointer prelative">
              中职教师培训
              <span class="pabsolute line"></span>
            </div>
            <div @click="trainType = 3" :class="{active: trainType == 3}"
              class="fs24 dflex justify-content-center align-items-center cpointer prelative">
              技能等级培训与认定
              <span class="pabsolute line"></span>
            </div>
          </div>
          <div class="pts pt15 pl35 pr10 prelative bgw">
            <div v-if="trainType == 3">
              <item-new v-for="(item,index) in skillAppraisal" :key="item['id']" :item="item" :trainType="trainType" @sign="sign"></item-new>
            </div>
            <div v-if="trainType == 5">
              <item-new v-for="(item,index) in specialWorkerTraining" :key="item['id']" :item="item" :trainType="trainType" @sign="sign"></item-new>
            </div>
            <div v-if="trainType == 4">
              <item-new v-for="(item,index) in secondaryVocationalTraining" :key="item['id']" :item="item"  :trainType="trainType" @sign="sign"></item-new>
            </div>
            <div v-if="trainType == 1">
              <item-new v-for="(item,index) in socialTraining" :key="item['id']" :item="item" :trainType="trainType" @sign="sign"></item-new>
            </div>
             <div class="tcenter pmore pabsolute">
              <router-link :to="{name: 'TrainProjectIndex', query: {trainType: trainType}}"
                class="tc6 more br2 trans3 fs14">
                更多项目内容&gt;&gt;
              </router-link>
            </div>
          </div>
        </div>

        <!--学习平台-->
        <div class="paimg tcenter mb25">
          <a href="http://zjjxjy.tzvtc.edu.cn/home/publics/login.html" class="dblock" target="_blank">
            <img width="100%" src="../../../assets/images/index_11_02.png" class="trans" />
          </a>
        </div>

        <!--通知 培训 政策-->
        <div class="fs0 tcenter">
          <div class="pn dinline-block fs0 mr15 vtop">
            <news :cont="notice" type="notice">
              <span class="tc">通知</span>公告
            </news>
          </div>
          <div class="pn dinline-block fs0 mr15 vtop">
            <news :cont="trainingInfoList" type="info">
              <span class="tc">培训</span>资讯
            </news>
          </div>
          <div class="pn dinline-block fs0 vtop">
            <news :cont="policiesRegulationsList" type="policies">
              <span class="tc">政策</span>法规
            </news>
          </div>
        </div>

        <div class="ht25"></div>

      </div>
    </div>
    <Bottom />
  </div>
</template>
<script>
// import '../../../assets/js/slidebox/jquery.slideBox.css'
import Top from '../top'
import Banner from '../banner'
import Bottom from '../bottom'
import TrainItem from '../../index/train-item.vue'
import TeachersItem from '../teachers-item'
import NoticeItem from './notice-item'
import InquiryItem from './inquiry-item'
import SignUp from '../project/signUp'
import SignUpZz from '../project/signUpZz'
import ItemJn from '../project/itemJn'
import QRCode from 'qrcodejs2'
import News from './news'
import ItemNew from '../project/ItemNew'
export default {
  name: 'index',

  components: {
    Top,
    Banner,
    Bottom,
    TrainItem,
    TeachersItem,
    NoticeItem,
    InquiryItem,
    SignUp,
    SignUpZz,
    ItemJn,
    News,
    ItemNew
  },

  data () {
    return {
      'spe_type': {
        1: '高压电工初训',
        2: '高压电工复训'
      },
      'trains': [],
      'notice': [],
      'inquiry': [],
      'teachers': [],
      'isNotice': true,
      'policiesRegulationsList': [],
      'trainingInfoList': [],
      'trainType': 1,
      'socialTraining': [],
      'specialWorkerTraining': [],
      'skillAppraisal': [],
      'secondaryVocationalTraining': [],
      'isSignUp': false,
      'isSignUpZz': false,
      'projectId': 0,
      'projectName': '',
      'classId': 0
    }
  },

  created () {
    this.getData()
  },

  mounted () {
    // this.slideBox();
  },

  updated () {
    // this.slideBox();
    // this.$nextTick(() => {
    //   for (var ind in this.specialWorkerTraining) {
    //     this.creatQrCode('qrcode-div' + this.specialWorkerTraining[ind]['id'], this.specialWorkerTraining[ind][
    //       'id'
    //     ])
    //   }
    // })
  },

  methods: {
    // creatQrCode (qrCodeUrl, id) {
    //   var docd = document.getElementById(qrCodeUrl)
    //   var that = this
    //   if (docd) {
    //     docd.innerHTML = ''
    //     var qrcode = new QRCode(docd, {
    //       text: 'http://' + document.domain + that.$router.options.base + 'train/project/sign-up-tz?id=' +
    //           id, // 需要转换为二维码的内容
    //       width: 100,
    //       height: 100,
    //       colorDark: '#000000',
    //       colorLight: '#ffffff',
    //       correctLevel: QRCode.CorrectLevel.H
    //     })
    //   }
    // },
    getData () {
      var params = {}
      this.$request.get('training-skill/index', params, response => {
        if (response.status == 200) {
          // console.log(response.data.data.calendar_data)
          // this.trains = response.data.data.promotionTrainingProgram;
          this.notice = response.data.data.noticeList
          this.inquiry = response.data.data.trainingConsultationList
          this.teachers = response.data.data.teacherList
          this.policiesRegulationsList = response.data.data.policiesRegulationsList
          this.trainingInfoList = response.data.data.trainingInfoList
          this.socialTraining = response.data.data.socialTraining.noticeList
          this.specialWorkerTraining = response.data.data.specialWorkerTraining.noticeList
          this.skillAppraisal = response.data.data.skillAppraisal.noticeList
          this.secondaryVocationalTraining = response.data.data.secondaryVocationalTraining.noticeList
          // console.log(this.specialWorkerTraining)
        }
      }, error => {
        console.log(error)
      })
    },
    signUpItemZzH () { //特种工
      this.isSignUpZz = false
      console.log('父组件signUpItemZzH：' + this.isSignUpZz)
    },
    signUpItem (obj) { //社会
      this.projectName =  obj.name
      this.projectId = obj.project_id
      this.classId = obj.class_id
      this.isSignUp = true
    },
    signUpItemZz (obj) { //中职
      this.projectId = obj.project_id
      this.classId = obj.class_id
      this.isSignUpZz = true
      console.log('父组件signUpItemZz：' + this.isSignUpZz)
    },
    sign (item) { //社会和中职
      let {id, name,trainProject} = item
      let type_id = trainProject.type_id
      let project_id = trainProject.id
      let obj = {
        project_id,
        class_id: id,
        name
      }
      console.log(obj)
      //console.log(obj)
      if (type_id == 4){ // 中职培训
        this.signUpItemZz(obj) 
      } else if (type_id == 1) {// 社会培训
         this.signUpItem(obj) 
      }
    }
  }
}
</script>

<style scoped>
  .sys {
    margin-top: -45px;
  }

  .sys .zbtn {
    padding: 10px 45px 0 85px;
    height: 72px;
    background: #5ba4e5 url(../../../assets/images/cn1.png) 10px -423px;
    text-align: left;
  }

  .sys .zbtn:hover {
    background-color: #147ad8;
  }

  .px-bg {
    background: #679fd4 url(../../../assets/images/index_05_04.jpg) no-repeat center top;
  }

  .pindex-wrap .more:hover {
    color: #147ad8;
  }

  .sts {
    margin-bottom: -1px;
    border-bottom: 3px solid transparent;
  }

  .sts.active {
    font-weight: bold;
    border-color: #147ad8;
  }

  .sts.active .tc {
    color: #147ad8;
  }

  .nt {
    margin-bottom: 1px;
    height: 40px;
    line-height: 40px;
  }

  .nt:hover {
    font-weight: bold;
    color: #147ad8;
  }

  .lms {
    width: 440px;
    height: 120px;
  }

  .lms:hover img {
    transform: scale(1.05);
  }

  .tbdiv span {
    padding: 6px 16px;
  }

  .tbdiv span.active {
    background: #147ad8 !important;
    color: #fff;
    border-radius: 15px;
  }

  .tbdiv span.noactive {
    background: #939393;
    color: #fff;
    border-radius: 15px;
  }

  .est {
    border-bottom: 1px solid #ddd;
  }

  .est .tt {
    margin-bottom: -1px;
  }

  .est .blue {
    border-bottom: 1px solid #1787e0;
  }

  .pnews {
    width: 370px;
  }

  .news:hover {
    font-weight: bold;
    color: #147ad8;
  }

  .news:hover::before {
    background: #147ad8;
  }

  .news {
    margin-bottom: 13px;
    padding-left: 18px;
    height: 24px;
  }

  .news::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 8px;
    width: 4px;
    height: 4px;
    background: #767778;
  }

  .cddiv {
    width: 400px;
  }

  .tz {
    font-size: 22px;
    margin-top: 15px;
    margin-left: 175px;
    height: 100px;
  }

  .tz span {
    color: rgb(102, 104, 103);
  }

  .tz span::before {
   /* content: url(../../../assets/images/tran.png);*/
    position: relative;
    top: 4px;
  }

  .tz-button {
    display: inline-block;
    text-align: center;
    margin-top: 10px;
    margin-left: 175px;
    width: 88px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    background: #147ad8;
    border: none;
    border-radius: 15px;
    color: #fff;
  }

  .qrcode-div {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100px;
    height: 100px;
    background: red;
  }

  .types {
    display: flex;
    width: 250px;
    height: 540px;
  }

  .types>div {
    flex: 1 1 100px;
    padding: 0 10px;
    background-color: #5ba4e5;
    border: 2px solid #5ba4e5;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    color: #fff;
  }

  .types .active {
    background-color: #fff;
    border-color: #1492ff;
    font-weight: bold;
    color: #1492ff;
  }

  .types .active .line {
    background-color: #fff;
  }

  .types .line {
    z-index: 1;
    right: -4px;
    width: 4px;
    height: 100%;
    top: 0;
  }

  .pts {
    width: 1030px;
    border: 2px solid #1492ff;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .pts .pmore {
    left: 0;
    right: 0;
    bottom: 18px;
  }

  .pts .more {
    padding: 7px 45px;
    border: 1px solid #999;
  }

  .pts .more:hover{
    font-weight: bold;
    background: #1492ff;
    border-color: #1492ff;
    color: #fff;
    transform: scale(1.05);
  }

  .paimg {
    overflow: hidden;
    width: 1280px;
    height: 122px;
    border-radius: 8px;
  }

  .paimg:hover  {
    /*box-shadow: 0 0 5px #1492ff;*/
  }

  .paimg:hover img{
    transform: scale(1.01);
  }

</style>


// WEBPACK FOOTER //
// src/components/train/index/index.vue